module.exports = __webpack_public_path__ + "static/media/resume.555113a9.png";